var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x96\x87\xE4\xBB\xB6",
    clipPath: "url(#clip0_122_152968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.28624 0.884915C9.30052 0.897147 9.31463 0.909826 9.32811 0.923308L11.9342 3.52938C11.9477 3.54286 11.9603 3.55697 11.9726 3.57125H9.42909C9.39121 3.57125 9.35487 3.5562 9.32808 3.52941C9.30129 3.50262 9.28624 3.46629 9.28624 3.4284V0.884915ZM8.71481 3.4284V0.714111H2.57195C2.38258 0.714324 2.20102 0.789647 2.06711 0.923556C1.9332 1.05746 1.85788 1.23902 1.85767 1.4284V12.5713C1.85788 12.7606 1.9332 12.9422 2.06711 13.0761C2.20102 13.21 2.38258 13.2853 2.57195 13.2855H11.4291C11.6185 13.2853 11.8 13.21 11.9339 13.0761C12.0678 12.9422 12.1432 12.7606 12.1434 12.5713V4.14268H9.42909C9.23972 4.14247 9.05816 4.06715 8.92425 3.93324C8.79034 3.79933 8.71502 3.61777 8.71481 3.4284Z",
    fill: "#FFAE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_152968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(0.142822 0.142822)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file.95cf82d0f1858b3b51d831a0cf6b08e7.svg";